export interface ParsedDescopeUsernameError {
  message: string;
  result: string;
  suggestions: string[];
}

/**
 * Parses a Descope error string that comes in the format:
 * "map[message:That username is already taken result:fail suggestions:[zach4 zach72 zach372 zach.l.dfsdf zach.l.dfsdf1]]"
 */
export function parseDescopeError(
  errorString: string
): ParsedDescopeUsernameError | null {
  if (!errorString || typeof errorString !== 'string') {
    return null;
  }

  try {
    // Remove "map[" prefix and "]" suffix
    const cleanedString = errorString.replace(/^map\[/, '').replace(/\]$/, '');

    // Extract message
    const messageMatch = cleanedString.match(
      /message:([^[\]]+?)(?=\s+result:|$)/
    );
    const message =
      messageMatch && messageMatch[1] ? messageMatch[1].trim() : '';

    // Extract result
    const resultMatch = cleanedString.match(
      /result:([^[\]]+?)(?=\s+suggestions:|$)/
    );
    const result = resultMatch && resultMatch[1] ? resultMatch[1].trim() : '';

    // Extract suggestions array
    const suggestionsMatch = cleanedString.match(/suggestions:\[([^\]]*)\]/);
    let suggestions: string[] = [];

    if (suggestionsMatch && suggestionsMatch[1]) {
      // Split by spaces and filter out empty strings
      suggestions = suggestionsMatch[1]
        .split(/\s+/)
        .filter(suggestion => suggestion.trim().length > 0);
    }

    return {
      message,
      result,
      suggestions,
    };
  } catch {
    // Failed to parse Descope error
    return null;
  }
}
